import{
    GET_NOTIFICATIONS,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAIL,
    GET_UNREAD_NOTIFICATIONS,
    GET_UNREAD_NOTIFICATIONS_SUCCESS,
    GET_UNREAD_NOTIFICATIONS_FAIL,
    DELETE_ALL_NOTIFICATIONS,
    DELETE_ALL_NOTIFICATIONS_SUCCESS,
    DELETE_ALL_NOTIFICATIONS_FAIL,
    DELETE_NOTIFICATION,
    DELETE_NOTIFICATION_SUCCESS,
    DELETE_NOTIFICATION_FAIL,
    MARK_AS_READ,
    MARK_AS_READ_FAIL,
    MARK_AS_READ_SUCCESS


} from './actionTypes'

export const getNotifications = () => ({
    type: GET_NOTIFICATIONS
})

export const getNotificationsSuccess = (notifications) => ({
    type: GET_NOTIFICATIONS_SUCCESS,
    payload: notifications
})

export const getNotificationsFail = (error) => ({
    type: GET_NOTIFICATIONS_FAIL,
    payload: error
})

export const getUnreadNotifications = () => ({
    type: GET_UNREAD_NOTIFICATIONS
})

export const getUnreadNotificationsSuccess = (unreadnotifications) => ({
    type: GET_UNREAD_NOTIFICATIONS_SUCCESS,
    payload: unreadnotifications
})

export const getUnreadNotificationsFail = (error) => ({
    type: GET_UNREAD_NOTIFICATIONS_FAIL,
    payload: error
})

export const DeleteAllNotifications= () => ({
    type: DELETE_ALL_NOTIFICATIONS
})

export const DeleteAllNotificationsSuccess = (notifications) => ({
    type: DELETE_ALL_NOTIFICATIONS_SUCCESS,
    payload: notifications
})

export const DeleteAllNotificationsFail = (error) => ({
    type: DELETE_ALL_NOTIFICATIONS_FAIL,
    payload: error
})

export const DeleteNotification = (id) => ({
    type: DELETE_NOTIFICATION,
    payload: id
})

export const DeleteNotificationSuccess = (notifications) => ({
    type: DELETE_NOTIFICATION_SUCCESS,
    payload: notifications
})

export const DeleteNotificationFail = (error) => ({
    type: DELETE_NOTIFICATION_FAIL,

    payload: error
})

export const MarkAsRead=(token,id)=>({
    type:MARK_AS_READ,
    payload:{token,id}
})

export const MarkAsReadSuccess=(notifications)=>({
    type:MARK_AS_READ_SUCCESS,
    payload:notifications
})

export const MarkAsReadFail=(error)=>({
    type:MARK_AS_READ_FAIL,
    payload:error
})
